export const isValidIranianNationalId = (value) => {
  if (!/^[0-9]{10}$/.test(value) || /^([0-9])\1{9}$/.test(value)) {
    return false;
  }

  const checksum = Number(value[9]);
  const sum = value
    .slice(0, 9)
    .split('')
    .reduce((total, digit, index) => total + Number(digit) * (10 - index), 0);
  const remainder = sum % 11;
  return remainder < 2 ? checksum === remainder : checksum === 11 - remainder;
};

export const normalizeShabaNumber = (value) => (
  typeof value === 'string' ? value.replace(/\s+/g, '').toUpperCase() : ''
);
